/* Built In Imports */

import React from 'react';
/* External Imports */

import { Box, Flex } from '@chakra-ui/react';
import { render } from 'datocms-structured-text-to-html-string';
/* Internal Imports */

import StructuredTextParser from '@components/Utility/ArticleParser/StructuredTextParser';
import config from '@config';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';

import MsrSectionTitle from '@msr/components/Headings/MsrSectionTitle';

/**
 *
 * @param {Object} sectionContent
 * @returns
 */

const Experience = ({ sectionContent, lang, region }) => {
  const imageUrl = sectionContent[2].image.url;
  const structuredTextContent = sectionContent[1]?.body?.value?.document; // Extracting the structured text content

  return (
    <Box pb={{ base: '4.5rem', md: '6rem' }}>
      <Box
        width={{ base: '100%' }}
        height={{ base: '23.25px', md: '44px' }}
        display={{ base: 'none', md: 'block' }}
      >
        <LazyLoadImageComponent
          src={`${config.staticPath}/d/46272/1739778629-group-1171276387.png`}
          height={'100%'}
          width={'100%'}
        />
      </Box>
      <Box
        width={{ base: '100%' }}
        height={{ base: '23.25px', md: '44px' }}
        display={{ base: 'block', md: 'none' }}
      >
        <LazyLoadImageComponent
          src={`${config.staticPath}/d/46272/1740056786-mask-group.png`}
          height={'100%'}
          width={'100%'}
        />
      </Box>

      <Box pt={{ base: '0rem', md: '3rem' }} pb={{ base: '2rem', md: '3rem' }}>
        <MsrSectionTitle titleObj={sectionContent[0]} />
      </Box>

      <Flex
        maxW={'965px'}
        width={{ md: '90%', lg: '100%' }}
        px={{ base: '1rem', md: '0rem' }}
        mx={{ md: 'auto' }}
        gap={{ base: '.5rem', md: '1rem', lg: '0' }}
        flexDir={{ base: 'column', md: 'row' }}
        justifyContent={{ md: 'space-between' }}
      >
        <Box
          w={{ base: '100%', md: '442px' }}
          h={{ base: '226px', md: '319px' }}
        >
          <LazyLoadImageComponent
            src={imageUrl}
            alt="no image"
            width={'100%'}
            height={'100%'}
            objectFit={'cover'}
          />
        </Box>

        {/* Box for rendering structured text */}
        <Box maxW={{ md: '483px' }} pr={{ xl: '.5rem' }}>
          <StructuredTextParser
            str={render(structuredTextContent)}
            fontFamily={'FedraSansStd-book'}
            className="structured-text"
            fontWeight={400}
            color="#FFFF"
            fontSize={{ base: '16px' }}
            lineHeight={{ base: '28px' }}
          />
        </Box>
      </Flex>
      <style jsx global>
        {`
          .structured-text p {
            fontweight: 300px;
            opactiy: '20%';
          }
          .host-structured-text strong {
            fontweight: 450px;
          }
        `}
      </style>
    </Box>
  );
};

export default Experience;
